import { SearchResultStatus } from '@retro-ui/shared';

import { ResultFilters } from '../components/filtering/SearchResultFilters';

import { parsePriceRange, parseRange } from './parseRange';
import { parseSorting } from './parseSorting';

export function deserializeFilters(searchParams: URLSearchParams): Partial<ResultFilters> {
  const targetFilter = searchParams.get('targetFilter');
  const status = searchParams.get('status');
  const sorting = searchParams.get('sorting');
  const result = searchParams.get('result');
  const reactionCount = searchParams.get('reactionCount');
  const price = searchParams.get('price');
  const filters = {
    targetFilter,
    status: status && (status.split(',') as SearchResultStatus[]),
    sorting: parseSorting(sorting),
    result: parseRange(result),
    reactionCount: parseRange(reactionCount),
    price: parsePriceRange(price),
  };
  return Object.fromEntries(Object.entries(filters).filter(([, value]) => Boolean(value)));
}
